import { RootState } from "store/store";
import { ITagAttribute } from "./types";

export const selectAllTagAttributes = (state: RootState): ITagAttribute[] => state.sideBarTreeSlice.tagAttributes